import { render } from "./IconCanceledByCustomer.vue?vue&type=template&id=0b7481ae"
import script from "./IconCanceledByCustomer.vue?vue&type=script&lang=js"
export * from "./IconCanceledByCustomer.vue?vue&type=script&lang=js"
script.render = render

export default script